import { Typography, List, Skeleton } from "antd";
import useFetch from "../../../hooks/useFetch";
import { useEffect, useState } from "react";

const { Title } = Typography;

function AreaDetails(props) {
  const { selectedArea } = props;

  const [fetchWrapper] = useFetch();

  const [loading, setLoading] = useState(false);

  const [powerMeterList, setPowerMeterList] = useState([]);

  /* API to get power meter list for selected area */
  function getSelectedAreaPowerMeterDetails() {
    setLoading(true);
    fetchWrapper({
      endpoint_url: "site_management/getSelectedAreaPowerMeterDetails",
      body: {
        area_id: selectedArea.ID,
      },
      onSuccess: (fetch_output) => {
        setLoading(false);
        if (fetch_output.status === true) {
          setPowerMeterList(fetch_output.power_meter_list);
        }
      },
    });
  }

  useEffect(() => {
    if (selectedArea) {
      getSelectedAreaPowerMeterDetails();
    }
  }, [selectedArea]);

  return (
    <>
      {loading ? (
        <Skeleton />
      ) : (
        <div>
          <Title level={3} className="mt-0">
            Device List
          </Title>

          {selectedArea ? (
            <div>
              <Title level={2} className="mt-0">
                {selectedArea ? selectedArea.Name : ""}
              </Title>

              {powerMeterList.length === 0 ? (
                <p>There is no power meter for this area.</p>
              ) : (
                <List
                  dataSource={powerMeterList}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              )}
            </div>
          ) : (
            <div>
              You can view the device list belongs to the area by clicking on
              the area name on the left hand side.
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default AreaDetails;
